import React, { useState } from 'react';
import { CreateFeatureDialog } from '../../../../components';
import { CreateAccordionMenuItemsData } from '../../../../components/create-feature-dialog/create-feature-dialog-helper';
import { useAuth, usePermission } from '../../../../core';
import { ROLES } from '../../../../core/contexts/permissions';
import { getFeatureMenuItemsByRoles } from '../../job-manager-helper';
import { useNavigate } from 'react-router-dom';
import { JOB_MANAGER_PATHS } from 'constants/job-manager-paths';

export const CreateJobView = (): React.JSX.Element => {
    const { getRoles } = useAuth();
    const [selectedOption, setSelectedOption] = useState<string>('');
    const [displayPermissionDialog, setDisplayPermissionDialog] =
        useState(false);
    const navigate = useNavigate();
    const { hasPermissions } = usePermission();

    const isUserRole: boolean = getRoles().includes(ROLES.user);
    const isAdminRole: boolean = getRoles().includes(ROLES.admin);
    const createJobFeatureMenuItems: CreateAccordionMenuItemsData[] =
        getFeatureMenuItemsByRoles(isUserRole, isAdminRole);

    const handleNext = (): void => {
        const permission = hasPermissions(['createData', 'createMetadata']);
        if (permission && selectedOption) {
            navigate(selectedOption);
        } else if (!permission) {
            setDisplayPermissionDialog(true);
        }
    };

    const handleClose = (): void => {
        navigate(JOB_MANAGER_PATHS.LANDING_PAGE);
    };

    const handlePermissionDialogClose = (): void => {
        setDisplayPermissionDialog(false);
    };

    return (
        <CreateFeatureDialog
            items={[]}
            handleNext={handleNext}
            handleClose={handleClose}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            displayPermissionDialog={displayPermissionDialog}
            handlePermissionDialogClose={handlePermissionDialogClose}
            headingText={'What would you like to do?'}
            isAccordionView
            accordionItems={createJobFeatureMenuItems}
        />
    );
};
